import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('disbursement/dashboard/statistics')
  }
}

export default DashboardService
